import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import mixins from './mixins'
import store from './store'

const app = createApp(App);
app.config.globalProperties.$socket = null;
app.config.globalProperties.$wsServerUri = "ws://www.0young0.pe.kr/";
app.config.globalProperties.$httpServerUri = "/";
//app.config.globalProperties.$wsServerUri = "ws://0young0.pe.kr:8091/";
//app.config.globalProperties.$httpServerUri = "https://cors-anywhere.herokuapp.com/http://0young0.pe.kr:8091/";
// app.config.globalProperties.$wsServerUri = "ws://127.0.0.1:8091/";
// app.config.globalProperties.$httpServerUri = "http://127.0.0.1:8091/";
app.config.globalProperties.$version = "0.0.6";
app.use(router);
app.mixin(mixins);
app.use(store);
app.mount('#app');